import { render, staticRenderFns } from "./StartsPage.vue?vue&type=template&id=370b4b48&"
import script from "./StartsPage.vue?vue&type=script&lang=js&"
export * from "./StartsPage.vue?vue&type=script&lang=js&"
import style0 from "./StartsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports